<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Kreiraj radnu listu</h3>
    </div>
    <div class="card-body">
      <form [formGroup]="worksheetForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Operacija</label>
              <app-dropdown [options]="developmentJobTaskNames"
                            [parentForm]="worksheetForm" 
                            [parentControl]="'task'"></app-dropdown>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Dodeljeno (MIN)</label>
              <input type="text" class="form-control" mask="separator.2" thousandSeparator="." decimalMarker="," formControlName="timeDelegatedEmployee" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Ostvareno (MIN)</label>
              <input type="text" class="form-control" mask="separator.2" thousandSeparator="." decimalMarker="," formControlName="timeConsumedEmployee" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Komentar</label>
              <textarea class="form-control" name="comment" formControlName="comment" rows="3"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="worksheetForm.invalid">Sačuvaj</button>
    </div>
  </div>
</div>